<template>
<div :class="['testimonial columns is-variable is-6', {'is-mobile': !is_mobile}]">
    <div class="column is-4" v-if="item.image.type == 'image'">
        <figure>
            <img :alt="item.image.thumb.title" :src="item.image.thumb.url" />
        </figure>
    </div>
    <div class="column is-4" v-else v-html="item.image.thumb"></div>
    <div class="column is-8">
        <div class="content" @click.prevent="handle_click" v-if="show_trimmed" v-html="trimmed"></div>
        <div class="content" v-else ref="content" v-html="item.content"></div>
        <div class="content">
            <p>{{item.credit}}<template v-if="item.creditor_title">, {{item.creditor_title}}</template></p>
        </div>
        <div class="news-item__cta has-text-right">
            <router-link class="colour-orange" :to="item.link" target="_blank">Read More ›</router-link>
        </div>
    </div>
</div>
</template>

<script>
import ViewBlockItemMixin from '@/components/mixins/ViewBlockItemMixin';
export default {
    name        :   'Testimonial',
    props       :   ['item', 'is_mobile'],
    mixins      :   [ ViewBlockItemMixin ],
    data()
    {
        return {
            show_trimmed    :   false
        };
    },
    computed    :   {
        trimmed()
        {
            if (this.item && this.item.content) {
                let words       =   this.item.content.trim().split(' '),
                    reserved    =   words.splice(0, 24),
                    shorter     =   reserved.length < this.item.content.trim().split(' ').length;

                return reserved.join(' ') + (shorter ? ' <a class="btn-expand">[...]</a>' : '' );
            }

            return null;
        }
    },
    mounted()
    {
        if (this.item) {
            this.show_trimmed   =   this.item.content.trim().split(' ').length > 24;
        }

        this.$nextTick().then(() => {
            if (this.$refs.content) {
                this.HandleContentedLinks(this.$refs.content, this)
            }
        })
    },
    methods     :   {
        handle_click(e)
        {
            if ($(e.target).is('.btn-expand')) {
                this.show_trimmed   =   false;
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/modules/elements/Testimonial.vue